import DOMPurify from "dompurify";
/**
 * Санитизация инлайн-SVG перед вставкой в DOM.
 *
 * `image_svg` из каталога пресетов — произвольный код и потенциально содержит
 * вредоносное (`<script>`, `on*`-обработчики). Инлайн нужен, чтобы работали
 * `fill/stroke="currentColor"` (через `<img>` это невозможно), но вставлять
 * сырой код нельзя. Прогоняем через DOMPurify с SVG-профилем: остаются только
 * безопасные SVG-элементы/атрибуты, скрипты и обработчики выпиливаются.
 */
export function sanitizeSvg(svg) {
    if (!svg || typeof svg !== "string") {
        return "";
    }
    try {
        return DOMPurify.sanitize(svg, {
            USE_PROFILES: { svg: true, svgFilters: true },
            // На всякий случай — запрещаем любые обработчики событий и внешние ссылки.
            FORBID_ATTR: ["onload", "onclick", "onerror", "onmouseover"],
            FORBID_TAGS: ["script", "foreignObject"],
        });
    }
    catch {
        return "";
    }
}
